/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useMemo, useState } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import useMenuDataOfficeController from "./MenuDataOfficeController";

import { ListMenuDataOffice } from "../sidebar/styles/Sidebar";

import { getSystemsInPreviewFromEntity } from "../../repositories/panel/v1/EntityRepository";
import { MenuItemPortal } from "./MenuItemPortal";
import { getEntitySystems } from "../../repositories/portal_api/Systems";
import { GlobalVariables } from "../../GlobalVariables";

export default function MenuPortal(props) {
  const {
    sidebar,
    companyUser,
    userLogged,
    animation,
    setSidebar,
    paramsQyonBot,
  } = useContext(GlobalContext);
  const [menusAccess, setMenusAccess] = useState([]);
  const [menusAccessTmp, setMenusAccessTmp] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);
  const {
    userPermissons,
    isAccountant,
    isClient,
    isStandaloneClient,
    isInClientView,
    optionsMenu,
    optionSubMenus,
    push,
    handleProductMenuHide,
    validateProductStatus,
    disconnect,
  } = useMenuDataOfficeController();

  const optionsMenus = useMemo(() => {
    return optionsMenu;
  }, [
    isClient,
    isStandaloneClient,
    userPermissons.customerManagement,
    userPermissons.gestaoFacil,
    userPermissons.contabil,
    userPermissons.fiscal,
    userPermissons.folha,
    userPermissons.cnd,
    userPermissons.crm,
    userPermissons.xml,
    companyUser.isAccountant,
    companyUser.document,
    companyUser.accountantCnpj,
    companyUser.accountantId,
    userLogged.token,
    userLogged.tokenCognito,
    handleProductMenuHide,
    validateProductStatus,
    isAccountant,
    isInClientView,
    push,
    disconnect,
    paramsQyonBot,
  ]);

  useEffect(() => {
    const start = async () => {
      const systems = await getSystemsInPreviewFromEntity();

      const entitySystems = await getEntitySystems();

      let inPreview = {
        CONTABIL: false,
        FOLHA: false,
        FISCAL: false,
      };
      const baseUrls = {
        ACCOUNTING: "https://ct.qyon.com",
        PAYROLL: "https://fp.qyon.com",
        TAX_WRITING: "https://ef.qyon.com",
      };

      if (systems?.data?.length > 0) {
        for (let system of systems?.data) {
          inPreview[system?.system] = system?.beta_enabled;
        }

        for (let menu of optionSubMenus["ACCOUNTING"]) {
          if (menu.value === "PAYROLL") {
            if (inPreview.FOLHA === true) {
              menu.baseUrl = baseUrls[menu.value];
            }
          }

          if (menu.value === "ACCOUNTING") {
            if (inPreview.CONTABIL === true) {
              menu.baseUrl = baseUrls[menu.value];
            }
          }

          if (menu.value === "TAX_WRITING") {
            if (inPreview.FISCAL === true) {
              menu.baseUrl = baseUrls[menu.value];
            }
          }
        }
      }

      //GAMBIARRA PRO NOVO PRODUTO AUTOMAÇÃO CONTABIL

      let hasFiscalAutomation = false;
      let hasGf = false;
      let hasBackup = false;
      // eslint-disable-next-line no-unused-vars
      let hasOfx = false;
      let hasConectaZap = false;
      let hasRadar = false;
      let hasXml = false;

      if (entitySystems?.success) {
        if (entitySystems?.data?.length > 0) {
          entitySystems.data.forEach((system) => {
            if (
              system.system_id === GlobalVariables.SYSTEMS.Fiscal &&
              system.status === "A" &&
              system.system_version_id ===
                GlobalVariables.SYSTEM_VERSION_CODE.AUTOMACAO_FISCAL
            ) {
              hasFiscalAutomation = true;
            }

            if (
              system.system_id === GlobalVariables.SYSTEMS.XML &&
              system.status === "A" &&
              system.system_version_id !==
                GlobalVariables.SYSTEM_VERSION_CODE.XML_GF
            ) {
              hasXml = true;
            }

            if (
              system.system_id === GlobalVariables.SYSTEMS.ERP &&
              system.status === "A"
            ) {
              hasGf = true;
            }

            if (
              system.system_id === GlobalVariables.SYSTEMS.Fiscal &&
              system.status === "A"
            ) {
              hasGf = true;
            }

            if (
              system.system_id === GlobalVariables.SYSTEMS.BACKUP &&
              system.status === "A"
            ) {
              hasBackup = true;
            }

            if (
              system.system_id === GlobalVariables.SYSTEMS.OFX &&
              companyUser.isAccountant &&
              system.status === "A"
            ) {
              hasOfx = true;
            }

            if (
              system.system_id === GlobalVariables.SYSTEMS.CONECTA_ZAP &&
              system.status === "A"
            ) {
              hasConectaZap = true;
            }

            if (
              system.system_version_id ===
                GlobalVariables.SYSTEM_VERSION_CODE.RADAR &&
              system.status === "A"
            ) {
              hasRadar = true;
            }
          });
        }
      }
      let counterProducts = 0;
      let counterExtensions = 0;
      optionsMenus.map((menu) => {
        if (hasFiscalAutomation) {
          if (menu.value === "PAYROLL" || menu.value === "ACCOUNTING") {
            menu.hide = true;
          }

          if (menu.value === "TAX_WRITING" && !isClient) {
            menu.hide = false;
          }

          if (!hasGf) {
            if (
              menu.value === "ERP" ||
              menu.value === "BANK" ||
              menu.value === "BILL_TO_PAY"
            ) {
              menu.hide = true;
            }
          }
        }

        if (hasXml) {
          if (menu.value === "XML") {
            menu.hide = false;
          }
        }

        if (hasBackup) {
          if (menu.value === "BACKUP") {
            menu.hide = false;
          }
        }

        if (hasRadar && isAccountant) {
          if (menu.value === "RADAR") {
            menu.hide = false;
          }
        }

        //OFX IS NOW A FREE PRODUCT
        // if (hasOfx) {
        //   if (menu.value === "OFX") {
        //     menu.hide = false;
        //   }
        // }

        if (hasConectaZap && isAccountant) {
          if (menu.value === "CONECTA_ZAP") {
            menu.hide = false;
          }
        }

        if (menu.type === "product" && menu.hide === false) {
          counterProducts++;
        }

        if (menu.type === "extension" && menu.hide === false) {
          counterExtensions++;
        }

        return menu;
      });

      optionsMenus.map((menu) => {
        if (menu.value === "PRODUCTS" && counterProducts === 0) {
          menu.hide = true;
        }

        if (menu.value === "EXTENSIONS" && counterExtensions === 0) {
          menu.hide = true;
        }

        return menu;
      });

      // FIM DA GAMBIARRA
    };

    try {
      start().then(() => {
        const objectMenus = {};
        if (!Array.isArray(companyUser?.systemsPermissions)) {
          return;
        }

        if (companyUser) {
          for (let menu of companyUser?.systemsPermissions) {
            objectMenus[menu.id] = { url: menu.url };
          }
        }

        const arrMenus = [];

        const hasPermissionForAccounting =
          companyUser?.systemsPermissions.filter(
            (e) => [5, 6, 2].includes(e.id) && e.status_product === "A"
          ).length > 0;

        if (optionsMenus?.length > 0) {
          optionsMenus.forEach((menu, i) => {
            if (menu.hide) return;

            if (menu.value === "XML" && !objectMenus[menu.systemId])
              menu.blur = true;

            let companyAccess = objectMenus[menu.systemId] ? true : false;

            if (menu.value === "ACCOUNTING") {
              companyAccess = hasPermissionForAccounting;
            }

            if (menu.value === "RADAR") {
              companyAccess = userPermissons.cnd;
            }

            if (menu.value === "CND") {
              companyAccess = userPermissons.cnd;
            }

            arrMenus.push({
              ...menu,
              showOrder: menu.order ?? i,
              companyAccess: companyAccess,
              baseUrl: objectMenus[menu.systemId]?.url,
            });
          });
        }

        try {
          for (let subitem of optionSubMenus["ACCOUNTING"]) {
            const systemId = subitem?.systemId;
            if (objectMenus[systemId]) {
              subitem.baseUrl = objectMenus[systemId]?.url;
              subitem.companyAccess = true;
            }
          }
        } catch (err) {}

        const ordenate = (a, b) => a.showOrder - b.showOrder;

        setMenusAccess(arrMenus.sort(ordenate));
        setMenusAccessTmp(arrMenus.sort(ordenate));
        setMenuLoading(false);
      });
    } catch (err) {
      console.error(err);
    }
  }, [companyUser, optionsMenus]);

  useEffect(() => {
    if (menuLoading) return;

    if (props.search === "") {
      setMenusAccessTmp(menusAccess);
      return;
    }

    // Find by menus
    let filterMenus = menusAccess.filter((menu) => {
      const label = menu.label.toLowerCase();
      const searchText = props.search.toLowerCase();

      return label.includes(searchText);
    });

    // Find by submenus
    let subItems = [];
    for (const key in optionSubMenus) {
      if (optionSubMenus.hasOwnProperty(key)) {
        for (let item of optionSubMenus[key]) {
          const label = item.label.toLowerCase();
          const searchText = props.search.toLowerCase();
          if (label.includes(searchText)) {
            const relatedParentElements = menusAccess.filter(
              (e) => e.value === key
            );
            if (relatedParentElements.length !== 0) {
              subItems = subItems.concat(relatedParentElements);
            }
          }
        }
      }
    }

    // Remove duplicated items
    subItems = subItems.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    );

    filterMenus = filterMenus.concat(subItems);

    // Remove duplicated items
    filterMenus = filterMenus.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.value === item.value)
    );

    setMenusAccessTmp(filterMenus);
  }, [props.search]);

  return (
    <>
      <ListMenuDataOffice style={{ color: "white", "overflow-x": "hidden" }}>
        {menusAccessTmp.map(({ ...props }) =>
          props.value !== "PRODUCTS" && props.value !== "EXTENSIONS" ? (
            <MenuItemPortal
              optionSubMenus={optionSubMenus}
              sidebar={sidebar}
              setSidebar={setSidebar}
              animation={animation}
              {...props}
            />
          ) : (
            <div
              style={{ padding: 10, display: props.hide ? "none" : "block" }}
            >
              <div
                style={{
                  justifyContent: "start",
                  alignItems: "center",
                  borderBottom: "1px solid #212121",
                  color: "#212121",
                  paddingBottom: 10,
                  fontFamily: "Roboto",
                  fontSize: 12,
                  fontWeight: 500,
                }}
              >
                {props.label}
              </div>
            </div>
          )
        )}
      </ListMenuDataOffice>
    </>
  );
}
